import { relationshipModel, UserRole } from '~/models';
export var Intent = /*#__PURE__*/ function(Intent) {
    Intent["AddPaymentMethod"] = "addPaymentMethod";
    Intent["AccountingMapServices"] = "accountingMapServices";
    Intent["AccountingSetupMapContacts"] = "accountingSetupMapContacts";
    Intent["InvoiceApprovePayment"] = "invoiceApprovePayment";
    Intent["InvoiceResolvePayment"] = "invoiceResolvePayment";
    Intent["InvoiceStopPayment"] = "invoiceStopPayment";
    Intent["InvoicePayNow"] = "invoicePayNow";
    Intent["InvoiceResumePayment"] = "invoiceResumePayment";
    Intent["ApproveCharge"] = "approveCharge";
    Intent["InviteTeamMember"] = "inviteTeamMember";
    Intent["DeclineAutoApproval"] = "declineAutoApproval";
    Intent["ApproveAllAmendments"] = "approveAllAmendments";
    Intent["InvoiceRejectPaymentExtension"] = "invoiceRejectPaymentExtension";
    Intent["InvoiceApprovePaymentExtension"] = "invoiceApprovePaymentExtension";
    Intent["InvoiceRetryCharge"] = "invoiceRetryCharge";
    Intent["ApproveAllBar"] = "approveAllBar";
    Intent["SelectPackage"] = "selectPackage";
    Intent["DownloadAgreementPdf"] = "downloadAgreementPdf";
    Intent["DuplicateAgreement"] = "duplicateAgreement";
    Intent["CopyRelationshipDirectLink"] = "copyRelationshipDirectLink";
    Intent["TerminateAgreement"] = "terminateAgreement";
    Intent["SendProposal"] = "sendProposal";
    Intent["SendProposalReminder"] = "sendProposalReminder";
    Intent["EditProposal"] = "editProposal";
    Intent["DuplicateProposal"] = "duplicateProposal";
    Intent["CancelProposal"] = "cancelProposal";
    Intent["InvoiceMarkPaidExternally"] = "invoiceMarkPaidExternally";
    Intent["InvoiceResend"] = "invoiceResend";
    Intent["InvoiceDownload"] = "invoiceDownload";
    Intent["InvoiceVoid"] = "invoiceVoid";
    Intent["InvoiceUnvoid"] = "invoiceUnvoid";
    Intent["InvoiceUnmarkPaidExternally"] = "invoiceUnmarkPaidExternally";
    Intent["InvoiceCopyLink"] = "invoiceCopyLink";
    Intent["UpdateBusinessDetails"] = "updateBusinessDetails";
    Intent["ChangeRole"] = "changeRole";
    Intent["ResendMemberInvitation"] = "resendMemberInvitation";
    Intent["RemoveFromTeam"] = "removeFromTeam";
    Intent["UpdateProfile"] = "updateProfile";
    Intent["OpenHelpMenu"] = "openHelpMenu";
    Intent["ApproveProposal"] = "approveProposal";
    Intent["ProposalSwitchCompany"] = "proposalSwitchCompany";
    Intent["AccountingMapAccounts"] = "accountingMapAccounts";
    Intent["AccountingDisconnect"] = "accountingDisconnect";
    Intent["ClientViewProposal"] = "clientViewProposal";
    Intent["VendorViewProposal"] = "vendorViewProposal";
    Intent["CreateProposalTemplate"] = "createProposalTemplate";
    Intent["EditProposalTemplate"] = "editProposalTemplate";
    Intent["ViewProposalTemplate"] = "viewProposalTemplate";
    Intent["UseProposalTemplate"] = "useProposalTemplate";
    Intent["RenameProposalTemplate"] = "renameProposalTemplate";
    Intent["DuplicateProposalTemplate"] = "duplicateProposalTemplate";
    Intent["RemoveProposalTemplate"] = "removeProposalTemplate";
    Intent["DiscardDraft"] = "discardDraft";
    Intent["AddCharge"] = "addCharge";
    Intent["AddCredit"] = "addCredit";
    Intent["RemoveCredit"] = "removeCredit";
    Intent["Bill"] = "bill";
    Intent["RemoveCharge"] = "removeCharge";
    Intent["ClientCreateVendorAccount"] = "clientCreateVendorAccount";
    Intent["RequestRefund"] = "requestRefund";
    Intent["SelectOptionalService"] = "selectOptionalService";
    Intent["ExportAgreementsToCsv"] = "exportAgreementsToCsv";
    Intent["ExportClientsToCsv"] = "exportClientsToCsv";
    Intent["ExportDraftsToCsv"] = "exportDraftsToCsv";
    Intent["ExportProposalsToCsv"] = "exportProposalsToCsv";
    Intent["BrandSetup"] = "brandSetup";
    Intent["CreateServiceTemplate"] = "createServiceTemplate";
    Intent["ApproveProposalOnBehalf"] = "approveProposalOnBehalf";
    Intent["InvoicePayAll"] = "invoicePayAll";
    Intent["RejectCharge"] = "rejectCharge";
    Intent["ApproveAmendment"] = "approveAmendment";
    Intent["RejectProposal"] = "rejectProposal";
    Intent["AddRelationshipNote"] = "addRelationshipNote";
    Intent["ManagePaymentMethod"] = "managePaymentMethod";
    Intent["UpdateBillingSettings"] = "updateBillingSettings";
    Intent["UpdateNotificationPreferences"] = "updateNotificationPreferences";
    Intent["ConnectIntegration"] = "connectIntegration";
    Intent["ManageNotifications"] = "manageNotifications";
    Intent["AuthorizeMandate"] = "authorizeMandate";
    Intent["RemindMandateReauthorization"] = "remindMandateReauthorization";
    Intent["StanfordTaxManageConnection"] = "stanfordTaxManageConnection";
    Intent["StanfordTaxMapServices"] = "stanfordTaxMapServices";
    Intent["BulkCreateDrafts"] = "bulkCreateDrafts";
    return Intent;
}({});
const viewModeReadOnlyIntents = new Set([
    "viewProposalTemplate",
    "vendorViewProposal",
    "openHelpMenu",
    "clientViewProposal",
    "exportAgreementsToCsv",
    "exportClientsToCsv",
    "exportDraftsToCsv",
    "exportProposalsToCsv"
]);
const openToAll = new Set([
    UserRole.Admin,
    UserRole.Member,
    UserRole.Owner,
    UserRole.AnchorAdmin,
    UserRole.Reviewer
]);
const openToOwnerAdminAndAnchorAdmin = new Set([
    UserRole.Admin,
    UserRole.Owner,
    UserRole.AnchorAdmin
]);
const openToAllExceptMembersAndReviewers = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.AnchorAdmin
]);
const openToAllExceptAnchorAdminAndReviewer = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member
]);
const openToAllExceptReviewer = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member,
    UserRole.AnchorAdmin
]);
const openToOwnerAndAdmin = new Set([
    UserRole.Admin,
    UserRole.Owner
]);
const openToOwnerAdminAndMember = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member
]);
const openToAllExceptAnchorAdmin = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member,
    UserRole.Reviewer
]);
const openToAdminAndMember = new Set([
    UserRole.Admin,
    UserRole.Member
]);
const accessControlAllowList = {
    ["addPaymentMethod"]: openToAll,
    ["accountingMapServices"]: openToOwnerAdminAndAnchorAdmin,
    ["accountingSetupMapContacts"]: openToOwnerAdminAndAnchorAdmin,
    ["accountingMapAccounts"]: openToAllExceptReviewer,
    ["accountingDisconnect"]: openToAllExceptReviewer,
    ["invoiceApprovePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceResolvePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceStopPayment"]: openToOwnerAndAdmin,
    ["invoicePayNow"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceResumePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["approveCharge"]: openToOwnerAndAdmin,
    ["inviteTeamMember"]: openToOwnerAdminAndAnchorAdmin,
    ["declineAutoApproval"]: openToOwnerAdminAndAnchorAdmin,
    ["approveAllAmendments"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceRejectPaymentExtension"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceApprovePaymentExtension"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceRetryCharge"]: openToOwnerAndAdmin,
    ["approveAllBar"]: openToOwnerAndAdmin,
    ["selectPackage"]: openToOwnerAdminAndAnchorAdmin,
    ["removeFromTeam"]: openToOwnerAdminAndAnchorAdmin,
    ["duplicateAgreement"]: openToAllExceptReviewer,
    ["terminateAgreement"]: openToAllExceptReviewer,
    ["sendProposal"]: openToAllExceptAnchorAdminAndReviewer,
    ["sendProposalReminder"]: openToAllExceptReviewer,
    ["editProposal"]: openToAllExceptReviewer,
    ["duplicateProposal"]: openToAllExceptReviewer,
    ["cancelProposal"]: openToAllExceptReviewer,
    ["invoiceMarkPaidExternally"]: openToOwnerAdminAndMember,
    ["invoiceResend"]: openToAllExceptReviewer,
    ["invoiceDownload"]: openToAll,
    ["invoiceVoid"]: openToOwnerAdminAndMember,
    ["invoiceUnvoid"]: openToAll,
    ["invoiceUnmarkPaidExternally"]: openToAll,
    ["invoiceCopyLink"]: openToAll,
    ["updateBusinessDetails"]: openToAllExceptReviewer,
    ["changeRole"]: openToAllExceptReviewer,
    ["resendMemberInvitation"]: openToAllExceptReviewer,
    ["updateProfile"]: openToAll,
    ["openHelpMenu"]: openToAllExceptReviewer,
    ["approveProposal"]: openToAdminAndMember,
    ["proposalSwitchCompany"]: openToAllExceptReviewer,
    ["downloadAgreementPdf"]: openToAll,
    ["copyRelationshipDirectLink"]: openToAll,
    ["clientViewProposal"]: openToAllExceptReviewer,
    ["vendorViewProposal"]: openToAll,
    ["createProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["editProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["viewProposalTemplate"]: openToAll,
    ["useProposalTemplate"]: openToAll,
    ["renameProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["duplicateProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["removeProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["discardDraft"]: openToAll,
    ["addCharge"]: openToAllExceptReviewer,
    ["addCredit"]: openToAllExceptAnchorAdminAndReviewer,
    ["removeCredit"]: openToAllExceptAnchorAdminAndReviewer,
    ["bill"]: openToAllExceptReviewer,
    ["removeCharge"]: openToAllExceptAnchorAdminAndReviewer,
    ["clientCreateVendorAccount"]: openToAllExceptAnchorAdmin,
    ["requestRefund"]: openToOwnerAdminAndAnchorAdmin,
    ["selectOptionalService"]: openToOwnerAdminAndAnchorAdmin,
    ["exportAgreementsToCsv"]: openToOwnerAdminAndAnchorAdmin,
    ["exportClientsToCsv"]: openToOwnerAdminAndAnchorAdmin,
    ["exportDraftsToCsv"]: openToOwnerAdminAndAnchorAdmin,
    ["exportProposalsToCsv"]: openToOwnerAdminAndAnchorAdmin,
    ["brandSetup"]: openToOwnerAdminAndAnchorAdmin,
    ["createServiceTemplate"]: openToAllExceptReviewer,
    ["approveProposalOnBehalf"]: openToOwnerAdminAndMember,
    ["invoicePayAll"]: openToOwnerAdminAndAnchorAdmin,
    ["rejectCharge"]: openToOwnerAndAdmin,
    ["approveAmendment"]: openToOwnerAdminAndAnchorAdmin,
    ["rejectProposal"]: openToAllExceptReviewer,
    ["addRelationshipNote"]: openToAllExceptReviewer,
    ["managePaymentMethod"]: openToAllExceptReviewer,
    ["updateBillingSettings"]: openToAllExceptReviewer,
    ["updateNotificationPreferences"]: openToAll,
    ["connectIntegration"]: openToAllExceptReviewer,
    ["manageNotifications"]: openToAll,
    ["authorizeMandate"]: openToOwnerAndAdmin,
    ["remindMandateReauthorization"]: openToAllExceptReviewer,
    ["stanfordTaxManageConnection"]: openToOwnerAdminAndAnchorAdmin,
    ["stanfordTaxMapServices"]: openToOwnerAdminAndAnchorAdmin,
    ["bulkCreateDrafts"]: openToOwnerAdminAndAnchorAdmin
};
function getForbiddenTooltipText(intent, primaryName, texts) {
    const name = primaryName || '';
    switch(intent){
        case "selectOptionalService":
            return texts.selectOptionalServiceTooltip({
                primaryName: name
            });
        case "selectPackage":
            return texts.selectPackageTooltip({
                primaryName: name
            });
        default:
            return texts.forbiddenTooltip();
    }
}
export function getIntentBehavior(userRole) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _opts_relationshipState, _opts_relationshipState1;
    const isSignatory = ((_opts_relationshipState = opts.relationshipState) === null || _opts_relationshipState === void 0 ? void 0 : _opts_relationshipState.relationship) && opts.userId && relationshipModel.isSignatory(opts.relationshipState.relationship, opts.userId);
    const primaryName = ((_opts_relationshipState1 = opts.relationshipState) === null || _opts_relationshipState1 === void 0 ? void 0 : _opts_relationshipState1.relationship) ? relationshipModel.buyerFullName(opts.relationshipState.relationship) : undefined;
    // eslint-disable-next-line no-console
    const warn = (intent)=>console.warn('[access-control] unrecognized intent:', intent);
    const isAllowed = (intent)=>{
        var _opts_relationshipState, _opts_relationshipState1, _opts_relationshipState2, _opts_relationshipState3;
        const isOwnerWithoutSignatories = ((_opts_relationshipState = opts.relationshipState) === null || _opts_relationshipState === void 0 ? void 0 : _opts_relationshipState.relationship) && UserRole.Owner === userRole && !relationshipModel.hasSignatories(opts.relationshipState.relationship);
        const isBuyer = ((_opts_relationshipState1 = opts.relationshipState) === null || _opts_relationshipState1 === void 0 ? void 0 : _opts_relationshipState1.relationship) && relationshipModel.isBuyer(opts.relationshipState.relationship, opts.userId);
        const isBuyerAdmin = isBuyer && (userRole === UserRole.Admin || userRole === UserRole.Owner);
        if (intent === "approveProposal" && (isSignatory || isOwnerWithoutSignatories || isBuyerAdmin)) {
            return true;
        }
        if (intent === "approveProposal" && isBuyer && !isBuyerAdmin) {
            return false;
        }
        const choosesSelections = ((_opts_relationshipState2 = opts.relationshipState) === null || _opts_relationshipState2 === void 0 ? void 0 : _opts_relationshipState2.relationship) && relationshipModel.choosesSelections(opts.relationshipState.relationship, opts.userId);
        if ((intent === "selectPackage" || intent === "selectOptionalService") && choosesSelections) {
            return true;
        }
        if (intent === "selectPackage" && ((_opts_relationshipState3 = opts.relationshipState) === null || _opts_relationshipState3 === void 0 ? void 0 : _opts_relationshipState3.isPreviewMode)) return true;
        const allowList = accessControlAllowList[intent];
        if (!allowList) {
            warn(intent);
            return true;
        }
        return allowList.has(userRole);
    };
    const isViewModeDenied = (intent)=>!!opts.isViewMode && !viewModeReadOnlyIntents.has(intent);
    return {
        getDisabled (intent) {
            if (!userRole) return false;
            if (isViewModeDenied(intent)) return true;
            return !isAllowed(intent);
        },
        getTooltip (intent) {
            if (!userRole || !opts.tooltips) return null;
            if (isViewModeDenied(intent)) return opts.tooltips.viewModeTooltip();
            return isAllowed(intent) ? null : getForbiddenTooltipText(intent, primaryName, opts.tooltips);
        }
    };
}
